import React, { useState } from 'react';
import ContactList from './ContactList';
import ContactEditList from '../ContactEditList';
import ContactDeleteList from '../ContactDeleteList';
import ContactExport from '../ContactExport';

const SidebarContact = ({ contactData, contactList, setLeadListId, setSearchTags, allTags }) => {
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [selectedContactList, setSelectedContactList] = useState(false);
  const [openModalExport, setOpenModalExport] = useState(false);

  // Handlers for modal state
  const handleEdit = contact => {
    setSelectedContactList(contact);
    setOpenModalEdit(true);
  };

  const handleDelete = contact => {
    setSelectedContactList(contact);
    setOpenModalDelete(true);
  };

  const handleExport = contact => {
    setSelectedContactList(contact);
    setOpenModalExport(true);
  };

  return (
    <div className="SidebarContact">
      <div className="sidebar-title">
        <span className="toggle-name">CONTACTS OVERVIEW</span>
      </div>

      <ContactList
        contactList={contactList}
        setSearchTags={setSearchTags}
        setLeadListId={setLeadListId}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        handleExport={handleExport}
      />

      <ContactEditList
        openModalEdit={openModalEdit}
        setOpenModalEdit={setOpenModalEdit}
        selectedContactList={selectedContactList}
        allTags={allTags}
      />
      <ContactDeleteList
        modalDeleteShow={openModalDelete}
        setModalDeleteShow={setOpenModalDelete}
        selectedContactList={selectedContactList}
      />
      <ContactExport
        openModalEdit={openModalExport}
        setOpenModalEdit={setOpenModalExport}
        selectedContactList={selectedContactList}
        contactData={contactData}
      />

    </div>
  );
};

export default SidebarContact;